import styled, {css} from 'styled-components';

export const OtpInputInnerWrapper = styled.div(
  props => `
      width:100%;
      display: flex;
      padding-bottom: ${props.theme.spacing.large.l20};
  `,
);

export const OtpInputWrapper = styled.div(
  props => `
      width: 100%;
      display: flex;

  `,
);

export const OtpInputBlock = styled.div(
  props => `
      width: 100%;
      display: flex;
      flex-direction: column;
  `,
);

export const OtpInputLabel = styled.label(
  props => `
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.black.base};
      text-transform: ${props.theme.font.textTransform.upper};
      font-weight: ${props.theme.font.fontWeight.bold};
  `,
);

export const OtpMainWrap = styled.div(
  props => `
      width:100%;
      display: flex;
      padding-top: ${props.theme.spacing.small.s7};
      padding-bottom: ${props.theme.spacing.small.s2};
  `,
);

export const OtpInput = styled.input(
  props =>`
  width: 4rem;
  height: 4.2rem;
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-right: ${props.theme.spacing.base};
  color: ${props.theme.colors.grey.base};
  border: 1px solid ${props.theme.colors.grey.lightd0};
  background-color: ${props.theme.colors.white.base};
  padding: ${props.theme.spacing.small.s5};
  font-size: ${props.theme.font.large.font18};
  text-align: center;
  cursor: pointer;

  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 3.6rem;
    height: 3.6rem;
    margin-right: ${props.theme.spacing.small.s5};
  }
  border-color: ${props.hasError ? props.theme.colors.red.base : ''};
`);

export const ResendBlock = styled.div(
  props => `
      width:100%;
      display: flex;
      align-items: center;

      @media only screen and (min-width:320px) and (max-width: 768px){
          padding-top: 0rem;
          justify-content: flex-end;
      }

      @media only screen and (min-width:1025px) and (max-width: 1300px){
          justify-content: flex-end;
      }
  `,
);

export const ResendText = styled.a(
  props => `
      font-size: ${props.theme.font.large.font14};
      color: ${props.theme.colors.blue.base};
      font-weight: ${props.theme.font.fontWeight.bold};
      cursor: pointer;
  `,
);

export const ResendTextDisabled = styled.a(
  props => `
      font-size: ${props.theme.font.large.font14};
      color: ${props.theme.colors.blue.base};
      font-weight: ${props.theme.font.fontWeight.bold};
      pointer-events: none;
      opacity: 0.5;
  `,
);

export const ErrorText = styled.span(
  props => `
      color: ${props.theme.colors.red.base};
      font-size: ${props.theme.font.small.font10};
    `,
);

export const OtpInputSubLabel = styled.span(
  props =>`
  font-size: ${props.theme.font.small.font11};
  color: ${props.theme.colors.grey.base2};
  text-transform: none;
`);

export const OtpBlockWrap = styled.div`
  width: 100%;
  display: flex;
  @media(max-width:768px){
    flex-direction: column;
  }
`;

export const OtpBlockInnerotpWrap = styled.div`
  width: 65%;
  display: flex;
  flex-direction: column;
`;

export const OtpBlockresendWrap = styled.div`
  width: 35%;
  display: flex;
  @media(max-width:768px){
    padding-top: 1rem;
    align-items: flex-end;
    width: 100%;
  }
`;
